import { render } from "./epdOrganization.vue?vue&type=template&id=234fae9d&scoped=true"
import script from "./epdOrganization.vue?vue&type=script&lang=js"
export * from "./epdOrganization.vue?vue&type=script&lang=js"

import "./epdOrganization.vue?vue&type=style&index=0&id=234fae9d&lang=scss"
import "./epdOrganization.vue?vue&type=style&index=1&id=234fae9d&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234fae9d"]])

export default __exports__